
export const navigation = 'Navigation';
export const home = 'Home';
export const about = 'About';
export const contact = 'Contact';
export const language = 'Language';
export const english = 'English';
export const french = 'Français';

// Home page
export const welcomeTitle = 'Creative Design Portfolio';
export const welcomeSubtitle = 'Discover my latest design projects and creative works';
export const viewGallery = 'View Gallery';
export const learnMore = 'Learn More';

// Gallery page
export const galleryTitle = 'My Design Gallery';
export const gallerySubtitle = 'A collection of my creative works and design projects';
export const allProjects = 'All Projects';
export const webDesign = 'le veau d\'or';
export const wildCherry = 'wild cherry';
export const illustration = 'Illustration';
export const photography = 'Photography';
export const viewProject = 'View Project';

// About page
export const aboutTitle = 'About';
export const aboutSubtitle = 'Art Director - Frenchette Group';
export const aboutDescription = 'I am an art director and consultant specializing in Brand Development with Frenchette Group. My involvement covers an exclusive domain encompassing all establishments under the umbrella of Frenchette Group: Frenchette, Frenchette Bakery, Le Rock, Frenchette Bakery At The Whitney, Le Veau d\'Or, and most recently WILD CHERRY in conjunction with A24 Entertainment at the historic Cherry Lane Theatre. My services include concept visualization, graphic art, menu design, music curating, social media campaigns, and promotional strategies. I provide creative and novel solutions to unique challenges, with primary focus on the core values and identity of the Frenchette Group brand.';
export const aboutServices = '• Graphics\n• Illustration\n• Menu Design\n• Merchandise\n• Name & Concept Development\n• Full Scale Branding - WILD CHERRY\n• Typography - WILD CHERRY, Le Veau d\'Or';
export const skills = 'Skills';
export const experience = 'Experience';
export const yearsExperience = 'Years of Experience';

// Contact page
export const contactTitle = 'davagraphiste@gmail.com';
export const contactSubtitle = 'Schedule to Discuss';
export const name = 'Name';
export const email = 'Email';
export const message = 'Message';
export const sendMessage = 'Send Message';
export const contactInfo = 'Contact Information';
export const phone = 'Phone';
export const location = 'Location';

// Le Veau d'Or page
export const leVeauDorCaption = 'Enter your text here...';

// Frenchette page
export const frenchetteCaption = 'Name, Brand Development & Artwork for Frenchette restaurant. Original "frenchette" logo designed by Mucca Design.';

export default {
  navigation,
  home,
  about,
  contact,
  language,
  english,
  french,
  welcomeTitle,
  welcomeSubtitle,
  viewGallery,
  learnMore,
  galleryTitle,
  gallerySubtitle,
  allProjects,
  webDesign,
  wildCherry,
  illustration,
  photography,
  viewProject,
  aboutTitle,
  aboutSubtitle,
  aboutDescription,
  aboutServices,
  skills,
  experience,
  yearsExperience,
  contactTitle,
  contactSubtitle,
  name,
  email,
  message,
  sendMessage,
  contactInfo,
  phone,
  location,
  leVeauDorCaption,
  frenchetteCaption
};
